const isEuropeanThousandsGrouped = (value: string): boolean => /^\d{1,3}(\.\d{3})+$/.test(value);

const isAmericanThousandsGrouped = (value: string): boolean => /^\d{1,3}(,\d{3})+$/.test(value);

const parseSalaryAmount = (raw: string): number | null => {
  const cleaned = raw.replace(/€/g, '').trim();
  if (cleaned === '') return null;

  const lastComma = cleaned.lastIndexOf(',');
  const lastDot = cleaned.lastIndexOf('.');

  let normalized: string;

  if (lastComma !== -1 && lastDot !== -1) {
    normalized = lastComma > lastDot ? cleaned.replace(/\./g, '').replace(',', '.') : cleaned.replace(/,/g, '');
  } else if (lastComma !== -1) {
    const afterComma = cleaned.slice(lastComma + 1);

    if (isAmericanThousandsGrouped(cleaned)) {
      normalized = cleaned.replace(/,/g, '');
    } else if (afterComma.length <= 2) {
      normalized = `${cleaned.slice(0, lastComma).replace(/\./g, '')}.${afterComma}`;
    } else {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    }
  } else if (lastDot !== -1) {
    const afterDot = cleaned.slice(lastDot + 1);
    normalized = isEuropeanThousandsGrouped(cleaned) || afterDot.length === 3 ? cleaned.replace(/\./g, '') : cleaned;
  } else {
    normalized = cleaned;
  }

  const value = Number(normalized);
  return Number.isFinite(value) ? value : null;
};

export const formatEuropeanEuroAmount = (raw: string): string | null => {
  const value = parseSalaryAmount(raw);
  if (value == null) return null;

  const hasCents = Math.round(value * 100) % 100 !== 0;

  if (hasCents) {
    const [intPart, decPart] = value.toFixed(2).split('.');
    const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `€${withThousands},${decPart}`;
  }

  const withThousands = Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `€${withThousands}`;
};

export const formatEuropeanEuroSalaryRange = (salaryRange: string): string => {
  const parts = salaryRange
    .split('-')
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length === 0) return '';

  const formattedParts = parts.map(
    (part) => formatEuropeanEuroAmount(part) ?? (part.includes('€') ? part : `€${part}`),
  );

  return formattedParts.join('-');
};
